<template>
  <v-row>
    <v-col
      v-if="diagnosticStats.tsa"
      cols="3"
    >
      <tsa-chart
        :stats="diagnosticStats"
      />
    </v-col>
    <v-col
      :cols="diagnosticStats.tsa ? 9 : 12"
    >
      <composite-diag-chart :stats="diagnosticStats" />
    </v-col>
  </v-row>
</template>
<script>
import { getColorForValue } from '@/utils/helpers'
import TsaChart from '@/components/charts/implementation/TsaChart.vue'
import CompositeDiagChart from '@/components/charts/implementation/CompositeDiagChart.vue'

export default {
  name: 'PlayerDiagnosticCompositeGraph',
  components: { CompositeDiagChart, TsaChart },
  props: {
    player: {
      type: Object,
      required: true
    },
    diagnosticStats: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    composite: 'composite'
  }),
  methods: { getColorForValue }
}
</script>

<style scoped>

</style>
